import { Formik } from "formik";
import { Button, Chip } from "@mui/material";

import Styles from "../Form.module.css";
import { useStore } from "../../../hooks/store";
import {
  enablePracticeToGroup,
  postSchoolGroup,
  updateSchoolGroup,
} from "../../../utils/API/schoolMethods";
import CustomField from "../../shared/CustomTextField";
import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  getUserRowStyle,
  userColumns,
} from "../../../utils/gridHelper";
import { useCallback, useMemo, useState } from "react";
import { Add, CarCrash, Delete, PlusOne } from "@mui/icons-material";
import UserSmallGrid from "./UserSmallGrid";
import GridToolBar from "../../GridToolBar";
import { deleteUserToGroup } from "../../../utils/API/userMethods";

export default function SchoolGroupForm() {
  const store = useStore();
  const [groupData, setGroupData] = useState();
  const { id, name, description, school_id, grouped_users } =
    store.form.dataToUpdate;
  const initValues = {
    id: id || null,
    name: name || "",
    description: description || "",
    school_id: school_id,
  };

  const onGroupGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGroupData(grouped_users || []);
  }, []);

  const submitSchoolGroup = (values) => {
    postSchoolGroup(values, school_id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitSchoolGroupUpdated = (values) => {
    updateSchoolGroup(values, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const addUserToGroupOpener = () => {
    store.setChildModal(
      <UserSmallGrid />,
      (user) => {
        setGroupData([...groupData, user]);
      },
      {
        school_id: school_id,
        group_id: id,
      },
    );
  };

  const handlePracticeEnable = async () => {
    try {
      const res = await enablePracticeToGroup(id);
      if (res.status === 200) {
        store.setAlert(
          "Практика открыта для всех учеников в группе",
          "success",
        );
        setGroupData(
          grouped_users.map((u) =>
            u.role === 1 ? { ...u, is_practice_enable: 1 } : u,
          ),
        );
        return;
      }
    } catch (error) {
      console.error(error);
      store.setAlert("Ошибка изменения группы", "error");
    }
  };
  const handleUserToGroupDelete = (e) => {
    const userId = e.id;
    deleteUserToGroup(userId, id).then(({ data, status }) => {
      if (status === 200) {
        store.setAlert(data, "success");

        setGroupData(
          groupData.filter((student) => Number(student.id) !== Number(userId)),
        );
      }
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        id ? submitSchoolGroupUpdated(values) : submitSchoolGroup(values);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
      }) => (
        <>
          <p>{id ? "Изменнеие группы" : "Создание группы"}</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={{ width: "800px" }}>
              <div className={Styles.form_fields} style={{ width: "800px" }}>
                <CustomField
                  name="name"
                  label="Название группы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label="Комментарий к группе"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
                {id && (
                  <div
                    style={{
                      height: "250px",
                      width: "100%",
                      marginBottom: "20px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}>
                      <p>Список пользователей </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          alignItems: "center",
                        }}>
                        <Button
                          onClick={handlePracticeEnable}
                          variant="contained"
                          color="warning"
                          startIcon={<CarCrash />}>
                          Открыть практику
                        </Button>
                        <Button
                          onClick={addUserToGroupOpener}
                          variant="contained"
                          color="success"
                          startIcon={<Add />}>
                          Зачислить
                        </Button>
                      </div>
                    </div>
                    <AgGridReact
                      onGridReady={onGroupGridReady}
                      // onRowClicked={workerRowClickHandler}
                      gerRowId={getRowId}
                      rowData={groupData}
                      defaultColDef={defaultColDef}
                      tooltipShowDelay={500}
                      columnDefs={[
                        userColumns[0],
                        // userColumns[1],
                        {
                          field: "is_practice_enable",
                          headerName: "Доступ к практике",
                          // flex: 0.2,
                          editable: false,
                          headerTooltip: "",
                          cellRenderer: ({ data }) => {
                            console.log(data);
                            return (
                              data.is_practice_enable !== null && (
                                <Chip
                                  label={
                                    data.is_practice_enable
                                      ? "Октрыт"
                                      : "Закрыт"
                                  }
                                  color={
                                    data.is_practice_enable
                                      ? "success"
                                      : "warning "
                                  }
                                />
                              )
                            );
                          },
                        },

                        userColumns[4],
                        {
                          field: "",
                          headerName: "",
                          flex: 0.2,
                          editable: false,
                          headerTooltip: "",
                          cellRenderer: ({ data }) => {
                            const handleClick = async () => {
                              const confirmation = await window.confirm(
                                "Вы уверены что хотите отчислить пользователя",
                              );

                              if (confirmation) {
                                handleUserToGroupDelete(data);
                              }
                            };
                            return (
                              <Button
                                size={"small"}
                                color="error"
                                onClick={handleClick}>
                                <Delete color="error" />
                              </Button>
                            );
                          },
                        },
                      ]}
                      getRowStyle={getUserRowStyle}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
